import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
import { useMediaBreakpoint, useResponsiveProp } from '@pushpay/theming';
import { Box } from './box';
import { alignHMap } from './alignment';
const useStyles = createUseStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    width: 'auto'
  },
  stack: ({
    alignStackItemsH
  }) => ({
    flexDirection: 'column',
    alignItems: alignHMap[alignStackItemsH]
  }),
  item: ({
    space
  }) => ({
    display: 'flex',
    width: 'auto',
    '& + &': {
      paddingLeft: theme.SPACING[space]
    }
  }),
  stackItem: ({
    space
  }) => ({
    display: 'flex',
    width: 'auto',
    '& + &': {
      marginTop: theme.SPACING[space]
    }
  })
}));
export const Inline = ({
  classes: classesProp,
  className: classNameProp,
  component = 'div',
  reverseWhen = 'NEVER',
  space: spaceProp = 'XSMALL',
  stackWhen = 'NEVER',
  alignStackItemsH: alignStackItemsHProp = 'left',
  separator: separatorProp,
  children,
  ...rest
}) => {
  const isList = ['ol', 'ul'].includes(component);
  const itemComponent = isList ? 'li' : 'div';
  const space = useResponsiveProp(spaceProp);
  const stack = useMediaBreakpoint(stackWhen);
  const alignStackItemsH = useResponsiveProp(alignStackItemsHProp);
  const reverse = useMediaBreakpoint(reverseWhen);
  const classes = useStyles(classesProp, {
    space,
    alignStackItemsH
  });
  const className = clsx(classNameProp, classes.root, stack && classes.stack);
  const itemClassName = clsx(stack ? classes.stackItem : classes.item);
  const separator = separatorProp && /*#__PURE__*/React.createElement(Box, {
    component: itemComponent,
    space: "NONE",
    className: itemClassName
  }, typeof separatorProp === 'function' ? separatorProp() : separatorProp);
  const childCount = React.Children.count(children);

  const makeItem = rev => (acc, child, index) => {
    const wrappedChild = child && /*#__PURE__*/React.createElement(Box, {
      component: itemComponent,
      space: "NONE",
      className: itemClassName
    }, child);

    if (separator && rev ? index > 0 : index < childCount - 1) {
      return acc.concat([wrappedChild, separator]);
    }

    return acc.concat(wrappedChild);
  };

  const childrenArray = React.Children.toArray(children);
  const items = reverse ? childrenArray.reduceRight(makeItem(true), []) : childrenArray.reduce(makeItem(false), []);
  return /*#__PURE__*/React.createElement(Box, Object.assign({
    space: "NONE",
    component: component,
    className: className
  }, rest), React.Children.map(items, child => child));
};